import { createReducer } from 'redux-act';
import * as actions from '#app/actions/transfer';
import { TransferConstants } from 'finhelper';

interface TransferState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  types: unknown[];
  shotTopSelectType: boolean;
}

const initialState: TransferState = {
  modalVisible: false,
  form: {},
  types: TransferConstants.items(),
  shotTopSelectType: false,
};

const setTransferModalVisible = (state: TransferState, bool: boolean): TransferState => ({
  ...state,
  modalVisible: bool,
});

const closeTransferForm = (state: TransferState): TransferState => ({
  ...state,
  form: {},
  modalVisible: false,
  types: TransferConstants.items(),
  shotTopSelectType: false,
});

const transferFormSetTypes = (state: TransferState, types: unknown[]): TransferState => ({
  ...state,
  types,
});

const setTransferForm = (state: TransferState, form: Record<string, unknown>): TransferState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const setShowTopSelectType = (state: TransferState, bool: boolean): TransferState => ({
  ...state,
  shotTopSelectType: bool,
});

export default createReducer<TransferState>(
  {
    [actions.setTransferModalVisible as any]: setTransferModalVisible,
    [actions.setTransferForm as any]: setTransferForm,
    [actions.closeTransferForm as any]: closeTransferForm,
    [actions.transferFormSetTypes as any]: transferFormSetTypes,
    [actions.setShowTopSelectType as any]: setShowTopSelectType,
  },
  initialState
);
